<template>
  <div class="text-left" id="router" style="padding-top:3%" :style="viewStyle">
    <div class="pa-5">
      <h1 v-if="innerWidth<960" class="text-center DarkBlue">親愛的 {{$root.LOGININFO.name}} 您好</h1>
      <h1 v-if="innerWidth<960" class="text-center DarkBlue">歡迎使用認證ｅ網</h1>
      <h1 v-else class="text-center DarkBlue">~親愛的 {{$root.LOGININFO.name}} 您好，歡迎使用認證ｅ網~</h1>
    </div>
    <v-row class="my-1" style="justify-content: center">
      <div style="width:80%">
        <v-row style="justify-content: center">
          <v-col v-for="(item, index) in menuItems" :key="index" class="d-inline-block ma-2 DarkBlue"
          style="flex:1; min-width:430px; cursor:pointer; border-radius:26px; background:#FFF; position: relative"
          :style="[
            { minWidth: innerWidth > 600 ? '430px' : '250px' ,
              height: innerWidth > 600 ? '360px' : '250px' ,
              border: indexHover === index ? '2px solid #215DA7' : '2px solid #81C0E2' ,
              boxShadow: indexHover === index ? '3px 3px 3px 3px #E6E6E6' : '' ,
              backgroundImage: `url(${item.gender === 'female' ? images.femaleGesture : images.maleGesture})` ,
              backgroundSize: innerWidth > 600 ? 'auto': '40%',
              backgroundPosition: 'bottom right',
              backgroundRepeat: 'no-repeat' 
            }
          ]"
          @mouseover="indexHover = index" @mouseleave="indexHover = null" @click="redirectPath(item.path)">
            <div :style="{padding: innerWidth > 600 ? '30px' : '20px'}">
              <h1 class="m-0">{{ item.title }}</h1>
              <h2 v-if="item.subtitle1" class="m-0 pt-1">{{ item.subtitle1 }}</h2>
              <h2 v-if="item.subtitle2" class="m-0 pt-1">{{ item.subtitle2 }}</h2>
              <h2 v-if="item.subtitle3" class="m-0 pt-1">{{ item.subtitle3 }}</h2>
            </div>
          </v-col>
        </v-row>

        <v-row style="justify-content: center">
          <div v-if="(innerWidth >= 600 || index === 0)" 
          v-for="(item, index) in menuItems2" :key="index" 
          class="d-inline-block ma-2 DarkBlue text-center"
          style="flex:1; height: 160px; cursor: pointer; border-radius: 26px; background:#FFF"
          :style="[
            { border: indexHover === index+3 ? '2px solid #215DA7' : '2px solid #81C0E2' },
            { boxShadow: indexHover === index+3 ? '3px 3px 3px 3px #E6E6E6' : '' }
          ]"
          @mouseover="indexHover = index+3" @mouseleave="indexHover = null" @click="redirectPath(item.path)">
            <div style="height:100%; display:flex; flex-direction: column; justify-content:center; align-items:center;">
              <h2 class="m-0">{{ item.title }}</h2>
              <h2 v-if="item.subtitle" class="m-0 pt-1">{{ item.subtitle }}</h2>
            </div>
          </div>
        </v-row>

        <v-row class="my-5" justify="center" style="color:#777">
          <div style="display: flex; align-items: center;">
            <v-icon class="pr-2" size="32">mdi-phone</v-icon>
            <h4 class="pt-1 pr-7">電話：03- 4264248</h4>
          </div>
          <div style="display: flex; align-items: center;">
            <v-icon class="pr-2" size="32">mdi-email-outline</v-icon>
            <h4 class="pt-1 pr-5">service@cerps.org.tw</h4>
          </div>
          <div v-if="innerWidth>1075" style="display: flex; align-items: center;">
            <v-icon class="pr-2" size="32">mdi-facebook</v-icon>
            <h4 class="pt-1">中華企業資源規劃學會</h4>
          </div>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'HomePage',
  components: {},
  mounted(){
  },
  data:() => ({
    images:{
      femaleGesture: require('@/assets/image/femaleGesture.png'),
      maleGesture: require('@/assets/image/maleGesture.png'),
      registered: require('@/assets/image/registered.png'),
      verification: require('@/assets/image/verification.png')
    },
    datasets: [],
    destPage:'',
    viewStyle:{},
    innerWidth:0,
    indexHover: null,
    menuItems: [
      { title: "專案認證考試", gender: 'female', subtitle1: "・大型會考報名", subtitle2: "・實體/遠距/APP考試", subtitle3: "", path: "/registrationList" },
      { title: "報名資訊查詢", gender: 'male', subtitle1: "・前往繳費", subtitle2: "・下載電子證書", subtitle3: "・申請紙本證書", path: "/registerInformationList" },
    ],
    menuItems2: [
      { title: "遠距大型會考", subtitle: "立即報名", path: "/registrationCategoryList" },
      { title: "我的證照庫", path: "/myCertificateList" },
      { title: "帳號資料修改", path: "/profile" }
    ],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.$root.LOGININFO = {name:sessionStorage.getItem('cerpsMemberName')}
  },
  watch:{},
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
      this.innerWidth = window.innerWidth
    },
    redirectPath(path){
      this.$router.push(path)
    },
  }
}
</script>

<style scoped>
.gesture-img {
  position: absolute;
  bottom: 0;
  right: 0;
  max-height: 75%; /* Ensure it does not exceed 80% of the container's height */
  width: auto; /* Maintain aspect ratio */
}

@media (max-width: 600px) {
  .gesture-img {
    max-height: 50%; /* Reduce image size on smaller screens */
  }
  h1 {
    font-size: 1.7em;
  }

  h2 {
    font-size: 1.3em;
  }
}
</style>